import { ActivatedUser } from 'containers/Authentication/ActivatedUser'
import { Login } from 'containers/Authentication/Login'
import { Logout } from 'containers/Authentication/Logout'
import { CreatePassword } from 'containers/Authentication/Password/CreatePassword'
import { ForgotPassword } from 'containers/Authentication/Password/ForgotPassword'
import { ResetPassword } from 'containers/Authentication/Password/ResetPassword'
import React, { useContext } from 'react'
import { Route, Switch } from 'react-router'
import AppContext from '../Store/AppContext'
import { PrivateRoute } from './PrivateRoute'
import RouteSuspense from './RouteSuspense'

const Routes = () => {
  const { globalState } = useContext(AppContext as any)
  return (
    <Switch>
      <Route path="/user/activate/:token">
        <ActivatedUser />
      </Route>
      <Route path="/user/create-password/:token">
        <CreatePassword />
      </Route>
      <Route path="/reset-password/:token">
        <ResetPassword />
      </Route>
      <Route path="/forgot-password">
        <ForgotPassword />
      </Route>
      <Route path="/login">
        <Login />
      </Route>
      <Route path="/logout">
        <Logout />
      </Route>
      {globalState.routes.map((el, index) => {
        return (
          <PrivateRoute key={index} exact {...el.props}>
            <RouteSuspense>{el.component}</RouteSuspense>
          </PrivateRoute>
        )
      })}
    </Switch>
  )
}

export default Routes
